<div [@routerTransition]>


    <abp-modal-header
    [title]="'Users' | localize"
    (onCloseClick)="bsModalRef.hide()"
  ></abp-modal-header>


    <!-- <section class="content-header">
        <div class="container-fluid">
            <div class="row">
                <div class="col-6">
                    <h1>{{ "Users" | localize }}</h1>
                </div>
                
            </div>
        </div>
    </section> -->
    <section class="content px-2">
        <div class="container-fluid">
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col-md-6">&emsp;</div>
                        <div class="col-md-6">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button
                                            type="button"
                                            class="btn bg-blue"
                                            (click)="getDataPage(1)"
                                    >
                                        <i class="fas fa-search"></i>
                                    </button>
                                </div>
                                <input
                                        type="text"
                                        class="form-control"
                                        name="keyword"
                                        [placeholder]="'SearchWithThreeDot' | localize"
                                        [(ngModel)]="keyword"
                                        (keyup.enter)="getDataPage(1)"
                                />                          
                            </div>
                        </div>
                    </div>
                   
                </div>
                <div class="card-body">
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered" [busy]="isTableLoading">
                            <thead class="bg-light">
                            <tr>
                                <th>{{ "UserName" | localize }}</th>
                                <th>{{ "FullName" | localize }}</th>
                                <th>{{ "EmailAddress" | localize }}</th>
                                <th style="width: 310px;">{{ "Actions" | localize }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                    *ngFor="
                  let user of users
                    | paginate
                      : {
                          id: 'server',
                          itemsPerPage: pageSize,
                          currentPage: pageNumber,
                          totalItems: totalItems
                        }
                "
                            >
                                <td>{{ user.userName }}</td>
                                <td>{{ user.fullName }}</td>
                                <td>{{ user.emailAddress }}</td>
                                <td>
                                    <button
                                            type="button"
                                            class="btn btn-sm bg-primary"
                                            (click)="selected(user)"
                                    >
                                        <i class="fas fa-check"></i>
                                        {{ "select" | localize }}
                                    </button>
                                    
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card-footer table-card-footer bg-light border-top">
                    <div class="row">
                        <div class="col-sm-4 col-12 text-sm-left text-center">
                            <button class="btn btn-secondary" (click)="refresh()">
                                <i class="fas fa-redo-alt"></i>
                            </button>
                        </div>
                        <div class="col-sm-4 col-12 text-center">
                            <p class="mb-0 my-2">
                                {{ "TotalRecordsCount" | localize: totalItems }}
                            </p>
                        </div>
                        <div class="col-sm-4 col-12">
                            <div class="float-sm-right m-auto">
                                <abp-pagination-controls
                                        id="server"
                                        (pageChange)="getDataPage($event)"
                                >
                                </abp-pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
